module.exports = __webpack_public_path__ + "img/zz12.d48da53b.png";